/* ============================================================
   HORCERY — Desktop drag-to-scroll for carousels.
   Any [data-hz-drag] scroller becomes grab-and-pull with the mouse.
   Mouse only — touch keeps native scrolling. Suppresses the click
   that would otherwise fire on a child link after a drag.
   ============================================================ */
(function () {
  'use strict';

  function initDrag(el) {
    if (el.__hzDrag) return;
    el.__hzDrag = true;

    var down = false, startX = 0, startScroll = 0, moved = false;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return; // desktop mouse only
      if (e.button !== 0) return;
      down = true; moved = false;
      startX = e.clientX; startScroll = el.scrollLeft;
      el.classList.add('is-grabbing');
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    function end() { if (!down) return; down = false; el.classList.remove('is-grabbing'); }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);

    // Swallow the click that follows a drag so card links don't fire.
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initAll() { document.querySelectorAll('[data-hz-drag]').forEach(initDrag); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
